import Link from '@mui/material/Link'
import { FC, MouseEventHandler } from 'react'
import { IoChevronBack } from 'react-icons/io5'

interface BackButtonProps {
    onBack: MouseEventHandler
    text: string
}

export const BackButton: FC<BackButtonProps> = ({ onBack, text }) => (
    <Link component="button" onClick={onBack} variant="body1" gap="0.5rem">
        <IoChevronBack size="1rem" />
        {text}
    </Link>
)
